import { SubmitContactForm } from "../../Models/Support";
import api from "../axios";

export const supportService = {
  submitContactForm: async (data: SubmitContactForm): Promise<boolean> => {
    const response = await api.post('/support/contact-form', data);
    return response.data;
  }
};
